import './Sidebar.scss'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'
import { SIDEBAR_DATA } from './SidebarData'
import { useSelector } from 'react-redux'
import { selectUser } from '../../pages/login-page/LoginAuthSlice'

const SidebarMenuItems = ({ el }) => {
  
  
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const activeRoute = matchPath(`/${el.route}/*`, pathname)
  const activeClassName = activeRoute ? 'Active' : ''


  return (
    <div className={`${activeClassName} IconContainer flex justify-content-center my-1 relative`} onClick={() => navigate(el.route)}>
      <div className="IconActive">{el.icon}</div>
      <div className="IdentifierTag h-full  absolute top-0 left-100 text-white p-1 px-3">
        <div className="text-sm text-center h-full flex align-items-center">{el.labelText}</div>
      </div>
    </div>
  )
}
const Sidebar = () => {

  const loggedInUser = useSelector(selectUser)
  let isSuperAdmin = loggedInUser?.isSuperAdmin ?? false

  const sidebarItems = SIDEBAR_DATA.filter(item => {

    if (item.onlySuperAdmin && isSuperAdmin) {
      return item
    }

    if (!item.onlySuperAdmin){
      return item
    }


  })

  return (
    <div className='Sidebar flex flex-column p-2'>
      {sidebarItems.map((el, _id) => <SidebarMenuItems  key={_id} el={el} />)}
    </div>
  )
}

export default Sidebar